"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var antd_1 = require("antd");
var mapbox_gl_1 = __importDefault(require("mapbox-gl"));
var turf = __importStar(require("@turf/turf"));
require("@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css");
var mapbox_gl_draw_1 = __importDefault(require("@mapbox/mapbox-gl-draw"));
var mapbox_gl_geocoder_1 = __importDefault(require("@mapbox/mapbox-gl-geocoder"));
var isEqual_1 = __importDefault(require("../../../utils/isEqual"));
var mapbox_gl_draw_rectangle_mode_1 = __importDefault(require("mapbox-gl-draw-rectangle-mode"));
var mapbox_gl_draw_freehand_mode_1 = __importDefault(require("mapbox-gl-draw-freehand-mode"));
var api_1 = require("./api");
var transifex_1 = require("../../../transifex");
var _ = require("lodash");
var MapBox = function (props) {
    var apollo = client_1.useApolloClient();
    var mapContainer = react_1.useRef(null);
    var map = react_1.useRef(null);
    var geoCoder = react_1.useRef(null);
    var markerDefault = react_1.useRef(null);
    var currentSources = react_1.useRef(undefined);
    var height = props.height, sources = props.sources, style = props.style, accessToken = props.accessToken, images = props.images, controls = props.controls, isLocationInput = props.isLocationInput, center = props.center, zoom = props.zoom;
    currentSources.current = sources;
    var handleDraw = function () {
        var draw = new mapbox_gl_draw_1.default({
            displayControlsDefault: false,
            // Select which mapbox-gl-draw control buttons to add to the map.
            controls: {
                polygon: true,
                line_string: true,
                trash: true,
            },
            // Set mapbox-gl-draw to draw by default.
            // The user does not have to click the polygon control button first.
            // @ts-ignore
            modes: Object.assign(mapbox_gl_draw_1.default.modes, {
                draw_line_string: mapbox_gl_draw_freehand_mode_1.default,
                draw_polygon: mapbox_gl_draw_rectangle_mode_1.default,
            }),
        });
        // @ts-ignore
        map.current.addControl(draw);
        var containerIds = [];
        var inquiryIds = [];
        var getFlatIdArray = function (array) {
            return [].concat.apply([], array.map(function (item) { return item === null || item === void 0 ? void 0 : item.ids.map(function (id) { return id; }); }));
        };
        var updateIdStates = function () {
            if (controls === null || controls === void 0 ? void 0 : controls.setContainerIds)
                controls.setContainerIds(getFlatIdArray(containerIds));
            if (controls === null || controls === void 0 ? void 0 : controls.setInquiryIds)
                controls.setInquiryIds(getFlatIdArray(inquiryIds));
        };
        var removePolygonDataFromArray = function (polygon) {
            // remove the polygon and its features from the array
            containerIds = containerIds.filter(function (item) { return item.polygonId !== polygon.id; });
            inquiryIds = inquiryIds.filter(function (item) { return item.polygonId !== polygon.id; });
        };
        var updateIdArrays = function (features, polygon) {
            // storage for the ids within the polygon
            var containerIdsInArea = [];
            var inquiryIdsInArea = [];
            removePolygonDataFromArray(polygon);
            features.map(function (feature) {
                if (turf.booleanPointInPolygon(feature, polygon)) {
                    // only add the property, if the feature intersects with the polygon drawn by the user
                    if (feature.source === "containers") {
                        //checks if the container id is associated with the polygon already
                        if (!containerIdsInArea.includes(feature.properties.id)) {
                            containerIdsInArea.push(feature.properties.id);
                        }
                    }
                    if (feature.source === "inquiries") {
                        //checks if the inquiry id is associated with the polygon already
                        if (!inquiryIdsInArea.includes(feature.properties.id))
                            inquiryIdsInArea.push(feature.properties.id);
                    }
                }
            });
            containerIds.push({
                polygonId: polygon.id,
                ids: __spreadArray([], containerIdsInArea),
            });
            inquiryIds.push({
                polygonId: polygon.id,
                ids: __spreadArray([], inquiryIdsInArea),
            });
        };
        var updateMapFilters = function (polygon) {
            if (polygon) {
                // @ts-ignore
                map.current.setFilter("containers-highlighted-point", __spreadArray([
                    "in",
                    "id"
                ], (getFlatIdArray(containerIds) || "")));
                // @ts-ignore
                map.current.setFilter("inquiries-highlighted-point", __spreadArray([
                    "in",
                    "id"
                ], (getFlatIdArray(inquiryIds) || "")));
            }
            else {
                // @ts-ignore
                map.current.setFilter("containers-highlighted-point", ["in", "id", ""]);
                // @ts-ignore
                map.current.setFilter("inquiries-highlighted-point", ["in", "id", ""]);
            }
        };
        var updateArea = function (e) {
            if (e.features.length > 0) {
                // @ts-ignore
                var userPolygon = e.features[0];
                // generate bounding box from polygon the user drew
                var polygonBoundingBox = turf.bbox(userPolygon);
                var southWest = [polygonBoundingBox[0], polygonBoundingBox[1]];
                var northEast = [polygonBoundingBox[2], polygonBoundingBox[3]];
                // @ts-ignore
                var northEastPointPixel = map.current.project(northEast);
                // @ts-ignore
                var southWestPointPixel = map.current.project(southWest);
                var layersToInclude = [];
                if ((controls === null || controls === void 0 ? void 0 : controls.drawIncludeInquiries) && !(controls === null || controls === void 0 ? void 0 : controls.drawIncludeContainers))
                    layersToInclude = ["inquiries-unclustered-point"];
                if (!(controls === null || controls === void 0 ? void 0 : controls.drawIncludeInquiries) && (controls === null || controls === void 0 ? void 0 : controls.drawIncludeContainers))
                    layersToInclude = ["containers-unclustered-point"];
                if ((controls === null || controls === void 0 ? void 0 : controls.drawIncludeInquiries) && (controls === null || controls === void 0 ? void 0 : controls.drawIncludeContainers))
                    layersToInclude = [
                        "containers-unclustered-point",
                        "inquiries-unclustered-point",
                    ];
                // @ts-ignore
                var features = map.current.queryRenderedFeatures([southWestPointPixel, northEastPointPixel], { layers: layersToInclude });
                updateIdArrays(features, userPolygon);
                updateMapFilters(userPolygon);
                updateIdStates();
            }
        };
        var deleteIdsFromSelectedArea = function (e) {
            var userPolygon = e === null || e === void 0 ? void 0 : e.features[0];
            removePolygonDataFromArray(userPolygon);
            updateMapFilters(userPolygon);
            updateIdStates();
        };
        // @ts-ignore
        map.current.on("draw.create", updateArea);
        // @ts-ignore
        map.current.on("draw.delete", deleteIdsFromSelectedArea);
        // @ts-ignore
        map.current.on("draw.update", updateArea);
    };
    var addSources = function () {
        var _a;
        if (!currentSources.current)
            return;
        images === null || images === void 0 ? void 0 : images.forEach(function (_a) {
            var name = _a.name, image = _a.image, external = _a.external;
            if (external) {
                // @ts-ignore
                map.current.loadImage(image.toString(), function (error, img) {
                    // @ts-ignore
                    map.current.addImage(name, img);
                });
            }
            else {
                // @ts-ignore
                map.current.addImage(name, image);
            }
        });
        (_a = currentSources.current) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
            var source = _a.source, layers = _a.layers, sourceId = _a.sourceId;
            // @ts-ignore
            var mapSource = map.current.getSource(sourceId);
            if (mapSource)
                mapSource.setData(source.data);
            else {
                // @ts-ignore
                map.current.addSource(sourceId, source);
                layers.forEach(function (_a) {
                    var data = _a.data, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
                    // @ts-ignore
                    map.current.addLayer(data);
                    if (onClick) {
                        // @ts-ignore
                        map.current.on("click", data.id, function (e) {
                            // @ts-ignore
                            onClick(e, map.current);
                        });
                    }
                    if (onMouseEnter) {
                        // @ts-ignore
                        map.current.on("mouseenter", data.id, function (e) {
                            // @ts-ignore
                            onMouseEnter(e, map.current);
                        });
                    }
                    if (onMouseLeave) {
                        // @ts-ignore
                        map.current.on("mouseleave", data.id, function (e) {
                            // @ts-ignore
                            onMouseLeave(e, map.current);
                        });
                    }
                });
            }
        });
    };
    var handleInitializeMap = function () {
        if (map.current)
            return; // initialize map only once
        // @ts-ignore
        mapbox_gl_1.default.accessToken = accessToken;
        // @ts-ignore
        var newMap = new mapbox_gl_1.default.Map({
            // @ts-ignore
            container: mapContainer.current,
            style: style,
            center: [center.longitude, center.latitude],
            zoom: zoom,
        });
        // @ts-ignore
        map.current = newMap;
        if (props.setMapRef) {
            props.setMapRef(newMap);
        }
        // @ts-ignore
        map.current.on("load", function () {
            console.log("map on load", sources);
            // @ts-ignore
            map.current.resize();
            if (isLocationInput)
                handleGeoCoderUpdate();
            if ((controls === null || controls === void 0 ? void 0 : controls.drawIncludeContainers) || (controls === null || controls === void 0 ? void 0 : controls.drawIncludeInquiries)) {
                handleDraw();
            }
            addSources();
        });
    };
    var handleGeoCoderUpdate = function () {
        // @ts-ignore
        if (map.current.hasControl(geoCoder.current)) {
            // @ts-ignore
            map.current.removeControl(geoCoder.current);
        }
        // @ts-ignore
        if (markerDefault.current) {
            // @ts-ignore
            markerDefault.current.remove();
        }
        // @ts-ignore
        markerDefault.current = new mapbox_gl_1.default.Marker({ draggable: true })
            // @ts-ignore
            .setLngLat(map.current.getCenter())
            // @ts-ignore
            .addTo(map.current);
        // @ts-ignore
        markerDefault.current.on("dragend", function (ev) {
            controls &&
                controls.onGeoCode &&
                controls.onGeoCode({
                    longitude: ev.target._lngLat.lng,
                    latitude: ev.target._lngLat.lat,
                });
        });
        if ((controls === null || controls === void 0 ? void 0 : controls.geoCoder) && (controls === null || controls === void 0 ? void 0 : controls.onGeoCode)) {
            // @ts-ignore
            geoCoder.current = new mapbox_gl_geocoder_1.default(__assign(__assign({}, controls === null || controls === void 0 ? void 0 : controls.geoCoder), { 
                // @ts-ignore
                mapboxgl: mapbox_gl_1.default, accessToken: mapbox_gl_1.default.accessToken, marker: false, localGeocoderOnly: true, localGeocoder: function () { return []; }, externalGeocoder: function (query) { return __awaiter(void 0, void 0, void 0, function () {
                    var data, locations, e_1;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, apollo.mutate({
                                        mutation: api_1.MUTATION_SEARCH_LOCATIONS,
                                        variables: {
                                            search: query,
                                            country: (controls === null || controls === void 0 ? void 0 : controls.geoCoderCountry) || "dk",
                                        },
                                    })];
                            case 1:
                                data = (_b.sent()).data;
                                locations = ((_a = data === null || data === void 0 ? void 0 : data.searchLocation) === null || _a === void 0 ? void 0 : _a.locations) || [];
                                // return features
                                return [2 /*return*/, locations.map(function (_a) {
                                        var name = _a.name, longitude = _a.longitude, latitude = _a.latitude;
                                        return ({
                                            center: [longitude, latitude],
                                            geometry: {
                                                type: "Point",
                                                coordinates: [longitude, latitude],
                                            },
                                            properties: {
                                                accuracy: "street",
                                            },
                                            type: "Feature",
                                            place_name: name,
                                        });
                                    })];
                            case 2:
                                e_1 = _b.sent();
                                antd_1.message.error((e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || transifex_1.TX_SEARCH_REQUEST_FAILED);
                                return [2 /*return*/, []];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); } }));
            // @ts-ignore
            geoCoder.current.on("result", function (e) {
                // @ts-ignore
                if (markerDefault.current) {
                    // @ts-ignore
                    markerDefault.current.remove();
                }
                // @ts-ignore
                markerDefault.current = new mapbox_gl_1.default.Marker({ draggable: true })
                    .setLngLat(e.result.center)
                    // @ts-ignore
                    .addTo(map.current);
                // @ts-ignore
                geoCoder.current.setInput("");
                // @ts-ignore
                markerDefault.current.on("dragend", function (ev) {
                    controls &&
                        controls.onGeoCode &&
                        controls.onGeoCode({
                            name: (controls === null || controls === void 0 ? void 0 : controls.geoCoderUpdateName)
                                ? e.result.place_name
                                : undefined,
                            longitude: ev.target._lngLat.lng,
                            latitude: ev.target._lngLat.lat,
                        });
                });
                controls &&
                    controls.onGeoCode &&
                    controls.onGeoCode({
                        name: (controls === null || controls === void 0 ? void 0 : controls.geoCoderUpdateName)
                            ? e.result.place_name
                            : undefined,
                        longitude: e.result.center[0],
                        latitude: e.result.center[1],
                    });
            });
            // @ts-ignore
            map.current.addControl(geoCoder.current);
        }
    };
    react_1.useEffect(function () {
        handleInitializeMap();
    });
    react_1.useEffect(function () {
        if (!map.current)
            return; // wait for map to initialize
        // @ts-ignore
        if (!map.current.loaded())
            return;
        addSources();
    }, [isEqual_1.default(sources), isEqual_1.default(images)]);
    react_1.useEffect(function () {
        if (!map.current)
            return; // wait for map to initialize
        // @ts-ignore
        if (!map.current.loaded())
            return;
        handleGeoCoderUpdate();
    }, [
        controls === null || controls === void 0 ? void 0 : controls.geoCoderUpdateName,
        isEqual_1.default(props.center),
        controls === null || controls === void 0 ? void 0 : controls.geoCoderCountry,
    ]);
    // @ts-ignore
    return (react_1.default.createElement("div", { className: "wh-mapbox-container", ref: mapContainer, style: { height: height, overflow: "hidden" } }));
};
MapBox.defaultProps = {
    center: {
        longitude: 10.2128,
        latitude: 56.1523,
    },
    zoom: 10,
    height: 500,
    accessToken: "pk.eyJ1Ijoia3NhaWVkIiwiYSI6ImNqemRzZGFtbDAwb2YzaW1oYWhjbmZqOHAifQ.FIUeHT0EcfjhHqwcFf0CvA",
    style: "mapbox://styles/ksaied/ckshjjq3xhcrp17q6ay482s5k",
};
exports.default = MapBox;
